module.exports = __webpack_public_path__ + "media/property_card_placeholder.d345e67e.png";